var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStyle10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 282.6 329",
    style: {
      enableBackground: "new 0 0 282.6 329"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#E2EAE5;stroke-width:2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.3,27.3c0.8-9.6,8.3-17.3,18-18.3l32.5-3.2c52.6-5.2,105.6-5.2,158.3,0L252.6,9c9.6,1,17.2,8.6,18,18.3 l5.9,71.7c3.6,43.9,3.6,88,0,131.9l-5.9,71.7c-0.8,9.6-8.3,17.3-18,18.3l-32.5,3.2c-52.6,5.2-105.6,5.2-158.3,0l-32.5-3.2 c-9.6-1-17.2-8.6-18-18.3l-5.9-71.7c-3.6-43.9-3.6-88,0-131.9L11.3,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.3,27.4c0.8-9.1,7.9-16.4,17.1-17.3l32.5-3.2c52.6-5.2,105.5-5.2,158.1,0l32.5,3.2 c9.1,0.9,16.3,8.2,17.1,17.3l5.9,71.7c3.6,43.8,3.6,87.9,0,131.7l-5.9,71.7c-0.8,9.1-7.9,16.4-17.1,17.3l-32.5,3.2 c-52.6,5.2-105.5,5.2-158.1,0l-32.5-3.2c-9.1-0.9-16.3-8.2-17.1-17.3l-5.9-71.7c-3.6-43.8-3.6-87.9,0-131.7L12.3,27.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyle10);
export default __webpack_public_path__ + "static/media/style10.5e46311db8e73e16c7294135b9af6328.svg";
export { ForwardRef as ReactComponent };